import React from "react";
import classNames from "classnames";
import { getProfilePicture } from "utils/profilePicture";
import styles from "./ProfileAvatar.module.scss";

export interface ProfileAvatarProps {
    onClick?: () => void;
    url: string;
    alt: string;
    className?: string;
}
const ProfileAvatar = ({ onClick, url, alt, className }: ProfileAvatarProps) => {
    function handleClick() {
        if (onClick) {
            onClick();
        }
    }
    return (
        <img
            className={classNames(styles["profile-avatar"], className, {
                [styles["profile-avatar--clickable"]]: !!onClick,
            })}
            src={getProfilePicture(url)}
            alt={alt}
            onClick={handleClick}
        />
    );
};

export default ProfileAvatar;
